<script>
import Popup from './popup.vue';
import MineOption from '../select/mineOption.vue';
import MineSelect from '../select/mineSelect.vue';
import pcas from '../../assets/data/pcas.js';
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    name: "addressPopup",
    data() {
        return {
            isAdd: false,
            regions: [
                { text: '中国大陆', code: '+86' },
                { text: '中国香港', code: '+852' },
                { text: '中国澳门', code: '+853' },
                { text: '中国台湾', code: '+886' },
                { text: '新加坡', code: '+65' },
                { text: '新西兰', code: '+64' },
                { text: '美国', code: '+1' },
                { text: '加拿大', code: '+1' },
                { text: '日本', code: '+81' },
                { text: '马来西亚', code: '+60' },
                { text: '韩国', code: '+82' },
                { text: '西班牙', code: '+34' },
                { text: '阿根廷', code: '+54' },
                { text: '法国', code: '+33' },
                { text: '俄罗斯', code: '+7' },
                { text: '菲律宾', code: '+63' },
                { text: '泰国', code: '+66' },
                { text: '英国', code: '+44' },
                { text: '意大利', code: '+39' },
                { text: '巴西', code: '+55' },
                { text: '波兰', code: '+48' },
                { text: '奥地利', code: '+43' },
                { text: '巴拿马', code: '+507' },
            ],
            pcas: pcas,
            // 省市区选择
            selectedPCA: {
                province: null,
                city: null,
                district: null,
            },
            detail: {
                name: '',
                phone: '',
                // 配送地区
                region: '',
                // 手机号区号文字
                region_text: '中国大陆',
                region_code: '+86',
                // 省
                province: '',
                // 市
                city: '',
                // 区
                district: '',
                // 详细地址
                address: '',
                // 是否默认地址
                is_default: 0,
                is_top: 0,
            },
        };
    },
    computed: {},
    components: {
        MineSelect,
        MineOption,
        Popup
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            immediate: true,
            handler(val) {
                if (!val || Object.keys(val).length === 0) {
                    // 新增地址，重置数据
                    this.isAdd = true;
                    this.detail = {
                        name: '',
                        phone: '',
                        // 配送地区
                        region: '',
                        // 手机号区号文字
                        region_text: '中国大陆',
                        region_code: '+86',
                        // 省
                        province: '',
                        // 市
                        city: '',
                        // 区
                        district: '',
                        // 详细地址
                        address: '',
                        // 是否默认地址
                        is_default: 0,
                        is_top: 0,
                    };
                    this.selectedPCA = {
                        province: null,
                        city: null,
                        district: null,
                    };
                } else {
                    // 编辑地址，赋值数据
                    this.isAdd = false;
                    this.detail = {
                        ...val,
                        region: val.area.split(' ')[0], // 取出地区的第一个部分作为region
                        province: val.area.split(' ')[1] || '',
                        city: val.area.split(' ')[2] || '',
                        district: val.area.split(' ')[3] || '',
                        region_code: val.phone.split(' ')[0] || '',
                        region_text: val.phone.split(' ')[0] ? this.regions.find(item => item.code === val.phone.split(' ')[0] ).text : '',
                        phone: val.phone.split(' ')[1] || '',
                    };
                    // 设置省市区选择器状态
                    const provinceIndex = this.pcas.findIndex(
                        (item) => item.name === this.detail.province
                    );
                    if (provinceIndex !== -1) {
                        this.selectedPCA.province = provinceIndex;
                        const cityIndex = this.pcas[provinceIndex].children.findIndex(
                            (item) => item.name === this.detail.city
                        );
                        if (cityIndex !== -1) {
                            this.selectedPCA.city = cityIndex;
                            const districtIndex = this.pcas[provinceIndex].children[cityIndex].children.findIndex(
                                (item) => item.name === this.detail.district
                            );
                            if (districtIndex !== -1) {
                                this.selectedPCA.district = districtIndex;
                            }
                        }
                    }
                }
            },
        },
    },
    methods: {
        // 选择配送地区
        regionChoose(value) { 
            this.detail.region = value.text;
            // 重置省市区
            this.detail.province = '';
            this.detail.city = '';
            this.detail.district = '';
            this.selectedPCA = {
                province: null,
                city: null,
                district: null,
            };
        },
        // 选择省市区
        pcaChoose(value, index, type) { 
            if (type === 'province') {
                // 选择省并重置市区
                this.selectedPCA.province = index;
                this.selectedPCA.city = null;
                this.selectedPCA.district = null;
                this.detail.province = value.name;
                this.detail.city = '';
                this.detail.district = '';
            } else if (type === 'city') {
                // 选择市并重置区
                this.selectedPCA.city = index;
                this.selectedPCA.district = null;
                this.detail.city = value.name;
                this.detail.district = '';
            } else if (type === 'district') {
                // 选择区
                this.selectedPCA.district = index;
                this.detail.district = value.name;
            }
        },
        // 选择手机区号
        regionCodeChoose(value) { 
            this.detail.region_code = value.code;
            this.detail.region_text = value.text;
        },
        // 保存地址
        save() { 
            // 校验
            if (this.detail.region === '') {
                this.$showToast({ text: '请选择配送地区' });
                return;
            }
            if (this.detail.region == '中国大陆' && (this.detail.province === '' || this.detail.city === '' || this.detail.district === '')) {
                this.$showToast({ text: '请选择省市区/县' });
                return;
            }
            if (this.detail.address.trim() === '') {
                this.$showToast({ text: '请输入详细地址' });
                return;
            }
            if (this.detail.name.trim() === '') {
                this.$showToast({ text: '请输入收货人姓名' });
                return;
            }
            if (this.detail.phone.trim() === '') {
                this.$showToast({ text: '请输入手机号码' });
                return;
            }
            // 组装数据
            const saveData = {
                area: this.detail.region == '中国大陆' ? `${this.detail.region} ${this.detail.province} ${this.detail.city} ${this.detail.district}` : this.detail.region,
                address: this.detail.address,
                name: this.detail.name,
                phone: `${this.detail.region_code} ${this.detail.phone}`,
                is_default: this.detail.is_default ? 1 : 0,
            };
            // 编辑地址时添加id
            if (!this.isAdd) {
                saveData.id = this.data.id;
            }
            // 触发保存事件
            this.$emit('save', saveData, this.isAdd);
        },
    },
};
</script>

<template>
    <Popup class="address_popup" title="添加收货地址" :show="show" isShowClose @close="$emit('close')">
        <div class="form">
            <div class="item">
                <p class="name">配送至 *</p>
                <MineSelect :value="detail.region">
                    <template v-slot:value>{{ detail.region }}</template>
                    <MineOption v-for="(item, index) in regions" :key="index" 
                    :is-active="item.text == detail.region"
                    @click="regionChoose(item)">{{ item.text }}</MineOption>
                </MineSelect>
            </div>
            <!-- 如果选择了中国大陆 -->
            <div class="item" v-if="detail.region == '中国大陆'">
                <p class="name">省市区/县 *</p>
                <!-- 省 -->
                <MineSelect :value="detail.province">
                    <template v-slot:value>{{ detail.province }}</template>
                    <MineOption v-for="(item, index) in pcas" :key="index" 
                    :is-active="item.name == detail.province"
                    @click="pcaChoose(item, index, 'province')">{{ item.name }}</MineOption>
                </MineSelect>
                <!-- 市 -->
                <MineSelect :value="detail.city">
                    <template v-slot:value>{{ detail.city }}</template>
                    <template v-if="selectedPCA.province !== null">
                        <MineOption v-for="(item, index) in pcas[selectedPCA.province].children" :key="index" 
                        :is-active="item.name == detail.city"
                        @click="pcaChoose(item, index, 'city')">{{ item.name }}</MineOption>
                    </template>
                </MineSelect>
                <!-- 区/县 -->
                <MineSelect :value="detail.district">
                    <template v-slot:value>{{ detail.district }}</template>
                    <template v-if="selectedPCA.city !== null">
                        <MineOption v-for="(item, index) in pcas[selectedPCA.province].children[selectedPCA.city].children" :key="index" 
                        :is-active="item.name == detail.district"
                        @click="pcaChoose(item, index, 'district')">{{ item.name }}</MineOption>
                    </template>
                </MineSelect>
            </div>
            <div class="item">
                <p class="name">详细地址 *</p>
                <input type="text" placeholder="必填" ref="address" v-model="detail.address"/>
            </div>
            <div class="item">
                <p class="name">收货人姓名 *</p>
                <input type="text" placeholder="必填" ref="name" v-model="detail.name"/>
            </div>
            <div class="item">
                <p class="name">手机号码 *</p>
                <MineSelect class="region_code" :value="detail.region_code">
                    <template v-slot:value>
                        <div class="flex justify_between">
                            <p class="only_pc">{{ detail.region_text }}</p>
                            <p>{{ detail.region_code }}</p>
                        </div>
                    </template>
                    <MineOption v-for="(item, index) in regions" :key="index" 
                    :is-active="detail.region_code == item.code"
                    @click="regionCodeChoose(item)">
                        <div class="flex justify_between">
                            <p>{{ item.text }}</p>
                            <p>{{ item.code }}</p>
                        </div>
                    </MineOption>
                </MineSelect>
                <input type="tel" placeholder="必填" ref="phone" v-model="detail.phone"/>
            </div>
            <div class="item">
                <p class="name">设为默认</p>
                <div class="radio_group">
                    <label class="radio">
                        <input type="checkbox" value="1" v-model="detail.is_default"/>
                        <p class="text">设为默认收货地址</p>
                    </label>
                </div>
            </div>
            <!-- <div class="item btn_group justify_end">
                <div class="btn" @click="$emit('close')">取消</div>
                <div class="btn">完成</div>
            </div> -->
        </div>
        <div class="btn_group bottom flex justify_end">
            <div class="btn big" @click="$emit('close')">取消</div>
            <div class="btn big" @click="save">完成</div>
        </div>
    </Popup>
</template>

<style scoped lang="scss">
.address_popup{
    .bottom{
        margin-top: .2rem;
    }
    .form{
        .region_code{
            flex: none;
            width: 1.6rem;
        }
    }
}
</style>